export default {
  LOAN_ENQUIRY_TOP_BAR_HEIGHT: 110,

  OpenModuleTitle: "Borrow & Join",
  LOAN_ENQUIRY_SUCCESS: 0,
  LOAN_ENQUIRY_NOT_ELIGIBLE_RESPONSE: 1,
  LOAN_ENQUIRY_NO_CONTENT: 204,
  LOAN_ENQUIRY_NOT_FOUND: 404,
  LOAN_ENQUIRY_UNAUTHORIZED: 401,  
  inOutType_Income: "I",
  inOutType_Outgoing: "O",

  // Drawdown Method - Electronic Funds Transfer
  EFT: "EFT", 
  
  // Source of Repayment
  BenefitsToPayment: "BP",
  StandingOrder: "SO",
  PayrollMandate: "PM",

  PBCodes: {
    103: 103,         // LoanEnquiryNotFound
    106: 106,         // LoanEnquiryPending
    412: 412,         // Precondition failed
    413: 413,         // Loan Enquiry Token is not valid
  },

  DocumentStatus: {
    AwaitingUpload: 0,
    Uploaded: 1,
    OpenBankingConsentGiven: 2
  },

  OTP: {
    Expired: 1,
    Invalid: 2,
    TooManyFailedAttempts: 3
  },

  // https://docs.jumio.com/production/Content/Integration/Integration%20Channels/Acquisition%20Status%20and%20Error%20Codes.htm?Highlight=acquisitionStatus
  JumioAcquisitionStatus: {
    Success: "SUCCESS",
    Error: "ERROR"
  },

  IdVerificationStatus: {
    VerificationNotRequired: 0,
    AwaitingVerification: 1,
    VerificationPending: 2,
    VerificationSucceeded: 3,
    VerificationFailed: 4,
    VerificationExpired: 5,
    IdentityBlacklisted: 6
  },

  MembershipApplicationStatus: {
    Withdrawn: "W",
    Rejected: "R"
  },

  CSSBannerClass: {
    Warning: "WarningBanner",
    Info: "InfoBanner",
    Success: "SuccessBanner",
    Error: "ErrorBanner",
    GreenSuccess: "GreenSuccessBanner"
  },

  CommonBonds: {
    InsideCommonBond: 2,            
    OutsideCommonBond: 3,           
    WorkInArea: 4,                  
    LiveInArea: 5,                  
    FamilyMemberIsAMember: 6
  },

  EnquiryFormFields: {
    PersonalDetails: ["memberTitleID", "firstName", "surname", "email", "confirmEmail", "mobileNumber", "homePhoneNumber", "nin", "memberNumber", "dateOfBirth", "countryOfBirthID", "gender", "nationalityID", "payrollNumber", "loanDetailDescriptionID"],
    HouseholdDetails: ["address", "countryOfResidenceID", "accomodationTypeID", "yearsAtCurrentAddress", "prevAddress", "prevCountryOfResidenceID", "maritalStatusID", "numberOfDependants", "dependantsDateOfBirth"],
    EmploymentDetails: ["employmentStatusID", "occupationID", "memberEmployer", "employmentLength", "memberEmployerAddress"],
    IncomeFinancialDetails: ["InInOutID", "InFrequency", "InAmount"],
    ExpenditureFinancialDetails: ["OutgoingList", "OutInOutID", "OutFrequency", "OutAmount", "OutAgency", "OutBalance"],
    DrawdownDetails: ["drawdownMethodID", "DrawdownAccountNumber", "DrawdownSortCode"],
    RepaymentDetails: ["paymentMethodID", "repaymentAccount", "soBranchName", "soBranchAddress", "soAmount", "soFrequency", "pmFrequency", "pmAmount", "repaymentFirstDate"],
    MarketingConsent: ["textMarketingPermitted", "emailMarketingPermitted", "phoneMarketingPermitted", "postMarketingPermitted"],
    OtherPreferencesDetails: ["signUPForOnlineAccess", "preferElectronicStatement", "preferElectronicAGMBooklet"],
    DeclarationsDetails: ["memberInGoodHealth", "truthfulnessConfirmation", "notes"]
  }
};